module.exports = __webpack_public_path__ + "img/1@2x (4).cfebabb5.png";